import { SideAdvert } from "app/api/advert/advert.types";

interface SideAdvertCardProps {
  advert: SideAdvert;
  fillHeight?: boolean;
}

const SideAdvertCard = ({ advert, fillHeight }: SideAdvertCardProps) => {
  return (
    <a
      href={advert.link || "#"}
      className={`group relative block overflow-hidden rounded-lg duration-300 w-full bg-gray-100 dark:bg-gray-800 ${
        fillHeight ? "h-full" : ""
      }`}
      style={fillHeight ? undefined : { aspectRatio: "16/9" }}
      aria-label={advert.title || "Side advert"}
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <img
          src={advert.imageUrl?.replace(
            "https://ppnuploads.blob.core.windows.net/",
            "https://bucket.promotionalproductsnow.au/"
          ) ?? advert.imageUrl}
          alt={advert.title || "Advert"}
          loading="lazy"
          fetchPriority="low"
          decoding="async"
          sizes="240px"
          className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      {advert.title && (
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/60 to-transparent">
          <span className="text-white text-xs font-medium line-clamp-2">{advert.title}</span>
        </div>
      )}
    </a>
  );
};

export default SideAdvertCard;
